import { Component } from '@angular/core';

@Component({
    selector: 'app-import-docs',
    templateUrl: './import-docs.component.html',
    styleUrl: './import-docs.component.scss',
    standalone: false
})
export class ImportDocsComponent {

}
